import React, { useContext, useEffect, useState } from 'react'
import {
  // CAvatar,
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardFooter,
  // CCardHeader,
  CCol,
  CProgress,
  CRow,
  // CTable,
  // CTableBody,
  // CTableDataCell,
  // CTableHead,
  // CTableHeaderCell,
  // CTableRow,
} from '@coreui/react'
import { CChartLine } from '@coreui/react-chartjs'
import { getStyle, hexToRgba } from '@coreui/utils'
import { useHistory } from 'react-router-dom'
import { GlobalContext } from '../context/GlobalState'
// import WidgetsDropdown from '../../components/widgets/WidgetsDropdown'
// import WidgetsBrand from '../../components/widgets/WidgetsBrand'
import useAxios from 'axios-hooks'
import { DOBBY_ANALYTICS_API, ANALYTICS_API, WATCHTIME_TRAFFIC_API } from '../utils/urls'
import { AppContext } from '../context/app'
import moment from 'moment'
import { calStepSize } from '../utils/helper'
import UserCard from './userCard'
import RevenueCard from './revenueCard'
import BandwidthCard from './bandwidthCard'
import ViewCard from './viewCard'

export const convertTimeDuration = (minutes) => {
  if (minutes) {
    minutes = parseInt(minutes)

    return Number(minutes * 0.0166667).toFixed(2)
  } else {
    return 0
  }
}

const getDateLabels = (days, dataPoints = 8) => {
  let dateArr = []
  let startDate = moment().subtract(days, 'd').format('Do MMM YYYY')
  let toDate = moment().format('Do MMM YYYY')

  for (let index = 0; index < dataPoints; index++) {
    // console.log('date ', index, ` ${startDate} - ${toDate}`)

    dateArr.unshift([`${startDate}`, `${toDate}`])
    toDate = startDate
    startDate = moment(toDate, 'Do MMM YYYY').subtract(days, 'd').format('Do MMM YYYY')
  }

  return dateArr
}

const Dashboard = () => {
  const { signedIn } = useContext(GlobalContext)
  const { setLoader } = useContext(AppContext)
  const [trafficToggle, setTrafficToggle] = useState('Month')
  const [trafficDataset, setTrafficDataset] = useState([])
  const [trafficLabels, setTrafficLabel] = useState([])
  const [watchtimeStepSize, setWatchtimeStepSize] = useState(1)
  const [contentStepSize, setContentStepSize] = useState(1)
  const history = useHistory()

  useEffect(() => {
    if (!signedIn) {
      history.push({ pathname: '/login', state: '/login' })
    }
  })

  const getDateLabelsCards = (factor, dataPoints, days = 7) => {
    let dateArr = []
    let startDate = moment()
      .subtract(days * factor, 'd')
      .format('Do MMM YYYY')
    let toDate = moment().format('Do MMM YYYY')

    for (let index = 0; index < dataPoints; index++) {
      dateArr.unshift(`${startDate} - ${toDate}`)
      toDate = startDate
      startDate = moment(toDate, 'Do MMM YYYY')
        .subtract(days * factor, 'd')
        .format('Do MMM YYYY')
    }

    return dateArr
  }

  const [{ loading: watchtimeTrafficLoading }, watchtimeTrafficCall] = useAxios(
    {
      url: WATCHTIME_TRAFFIC_API,
      method: 'get',
    },
    { manual: true },
  )
  const [{ loading: contentTrafficLoading }, contentTrafficCall] = useAxios(
    {
      url: `${DOBBY_ANALYTICS_API}/content-traffic`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: contentAssetData }, contentAssetCall] = useAxios(
    {
      url: `${DOBBY_ANALYTICS_API}/content-asset-stat`,
      method: 'get',
    },
    { manual: true },
  )
  const [{ data: activeSubData }, activeSubCall] = useAxios(
    {
      url: `${ANALYTICS_API}/active-subscriver-count`,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    setLoader(contentTrafficLoading || watchtimeTrafficLoading)
  }, [contentTrafficLoading, watchtimeTrafficLoading])

  useEffect(() => {
    contentAssetCall()
    activeSubCall()
    trafficData(30, 7)
  }, [])

  const trafficData = async (unit, dataPoint) => {
    setTrafficLabel(getDateLabels(unit, dataPoint))

    let tempTrafficDataset = []
    let watchtimeStepArray = []
    let contentStepArray = []

    const contentTrafficData = await contentTrafficCall({
      params: {
        unit_window: unit,
        num_data_points: dataPoint,
      },
    })

    if (contentTrafficData.data?.success) {
      tempTrafficDataset.push({
        label: 'Contents Added',
        backgroundColor: hexToRgba(getStyle('--cui-info'), 10),
        borderColor: getStyle('--cui-info'),
        pointHoverBackgroundColor: getStyle('--cui-info'),
        pointBackgroundColor: getStyle('--cui-info'),
        borderWidth: 2,
        data: contentTrafficData.data?.data,
        yAxisID: 'y',
      })

      contentStepArray.push(...contentTrafficData.data?.data)
    }

    const watchtimeTrafficData = await watchtimeTrafficCall({
      params: {
        unit_window: unit,
        num_data_points: dataPoint,
      },
    })

    if (watchtimeTrafficData.data?.success) {
      let timeDatapointsArr = []
      watchtimeTrafficData.data?.data?.data_points.forEach((sec) => {
        return timeDatapointsArr.push(Number(convertTimeDuration(sec / 60)))
      })

      tempTrafficDataset.push({
        label: 'Watch Time Hours',
        backgroundColor: 'transparent',
        borderColor: getStyle('--cui-success'),
        pointHoverBackgroundColor: getStyle('--cui-success'),
        pointBackgroundColor: getStyle('--cui-success'),
        borderWidth: 2,
        data: timeDatapointsArr,
        yAxisID: 'y1',
      })

      watchtimeStepArray.push(...timeDatapointsArr)
      contentStepArray.push(...contentTrafficData.data?.data)
    }

    console.log('tempTrafficDataset', tempTrafficDataset)
    setWatchtimeStepSize(
      calStepSize(Math.min(...watchtimeStepArray), Math.max(...watchtimeStepArray)),
    )
    setContentStepSize(calStepSize(Math.min(...contentStepArray), Math.max(...contentStepArray)))
    setTrafficDataset(tempTrafficDataset)
  }

  const onTrafficTimeChange = (value) => {
    setTrafficToggle(value)
    const timeObj = {
      Week: {
        unit: 7,
        dataPoint: 7,
      },
      Month: {
        unit: 30,
        dataPoint: 7,
      },
      Quarter: {
        unit: 90,
        dataPoint: 7,
      },
    }
    trafficData(timeObj[`${value}`]?.unit, timeObj[`${value}`]?.dataPoint)
  }

  return (
    <>
      <CRow>
        <UserCard getDateLabels={getDateLabelsCards} />
        <RevenueCard getDateLabels={getDateLabelsCards} />
        <ViewCard getDateLabels={getDateLabelsCards} />
        <BandwidthCard getDateLabels={getDateLabelsCards} />
      </CRow>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={5}>
              <h4 id="traffic" className="card-title mb-0">
                Traffic
              </h4>
              {/* <div className="small text-medium-emphasis">January - July 2021</div> */}
            </CCol>
            <CCol sm={7} className="d-none d-md-block">
              {/* <CButton color="primary" className="float-end">
                <CIcon icon={cilCloudDownload} />
              </CButton> */}
              <CButtonGroup className="float-end me-3">
                {['Week', 'Month', 'Quarter'].map((value) => (
                  <CButton
                    color="outline-secondary"
                    key={value}
                    className="mx-0"
                    active={value === trafficToggle}
                    onClick={() => onTrafficTimeChange(value)}
                  >
                    {value}
                  </CButton>
                ))}
              </CButtonGroup>
            </CCol>
          </CRow>
          <CChartLine
            style={{ height: '340px', marginTop: '20px' }}
            data={{
              labels: trafficLabels,
              datasets: trafficDataset,
            }}
            options={{
              maintainAspectRatio: false,
              plugins: {
                legend: {
                  display: true,
                },
              },
              scales: {
                x: {
                  grid: {
                    drawOnChartArea: false,
                  },

                  ticks: {
                    // mirror: true,
                    // padding: 20,
                    align: 'center',
                  },
                },
                y: {
                  type: 'linear',
                  display: true,
                  position: 'left',
                  ticks: {
                    stepSize: watchtimeStepSize,
                  },
                },
                y1: {
                  type: 'linear',
                  display: true,
                  position: 'right',
                  ticks: {
                    stepSize: contentStepSize,
                  },
                  // grid line settings
                  grid: {
                    drawOnChartArea: false, // only want the grid lines for one axis to show up
                  },
                },
              },
              elements: {
                line: {
                  tension: 0.4,
                },
                point: {
                  radius: 0,
                  hitRadius: 10,
                  hoverRadius: 4,
                  hoverBorderWidth: 3,
                },
              },
            }}
          />
        </CCardBody>
        <CCardFooter>
          <CRow xs={{ cols: 1 }} md={{ cols: 5 }} className="text-center justify-content-between">
            <CCol className="mb-sm-2 mb-0">
              <div className="text-medium-emphasis">Total Contents</div>
              {contentAssetData ? (
                <strong>{contentAssetData?.data?.num_contents} </strong>
              ) : (
                <strong>--</strong>
              )}
              <CProgress thin className="mt-2" precision={1} color="success" value={100} />
            </CCol>
            <CCol className="mb-sm-2 mb-0">
              <div className="text-medium-emphasis">Total Videos</div>
              {contentAssetData ? (
                <strong>{contentAssetData?.data?.num_videos} </strong>
              ) : (
                <strong>--</strong>
              )}
              <CProgress thin className="mt-2" precision={1} color="info" value={100} />
            </CCol>
            <CCol className="mb-sm-2 mb-0">
              <div className="text-medium-emphasis">Total Images</div>
              {contentAssetData ? (
                <strong>{contentAssetData?.data?.num_images} </strong>
              ) : (
                <strong>--</strong>
              )}
              <CProgress thin className="mt-2" precision={1} color="warning" value={100} />
            </CCol>
            <CCol className="mb-sm-2 mb-0">
              <div className="text-medium-emphasis">Total Active Subscribers</div>
              {activeSubData ? <strong>{activeSubData?.data} </strong> : <strong>--</strong>}
              <CProgress thin className="mt-2" precision={1} color="danger" value={100} />
            </CCol>
            {/* <CCol className="mb-sm-2 mb-0">
              <div className="text-medium-emphasis">Total Storage</div>
              <strong>12GB </strong>
              <CProgress thin className="mt-2" precision={1} value={100} />
            </CCol> */}
          </CRow>
        </CCardFooter>
      </CCard>

      {/* <WidgetsBrand withCharts /> */}

      {/* <CRow>
        <CCol xs>
          <CCard className="mb-4">
            <CCardHeader>Traffic {' & '} Sales</CCardHeader>
            <CCardBody>
              <CRow>
                <CCol xs={12} md={6} xl={6}>
                  <CRow>
                    <CCol sm={6}>
                      <div className="border-start border-start-4 border-start-info py-1 px-3">
                        <div className="text-medium-emphasis small">New Clients</div>
                        <div className="fs-5 fw-semibold">9,123</div>
                      </div>
                    </CCol>
                    <CCol sm={6}>
                      <div className="border-start border-start-4 border-start-danger py-1 px-3 mb-3">
                        <div className="text-medium-emphasis small">Recurring Clients</div>
                        <div className="fs-5 fw-semibold">22,643</div>
                      </div>
                    </CCol>
                  </CRow>

                  <hr className="mt-0" />

                  <div className="progress-group mb-4">
                    <div className="progress-group-prepend">
                      <span className="text-medium-emphasis small">Monday</span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress thin color="info" value={34} />
                      <CProgress thin color="danger" value={78} />
                    </div>
                  </div>
                  <div className="progress-group mb-4">
                    <div className="progress-group-prepend">
                      <span className="text-medium-emphasis small">Tuesday</span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress thin color="info" value={56} />
                      <CProgress thin color="danger" value={94} />
                    </div>
                  </div>
                  <div className="progress-group mb-4">
                    <div className="progress-group-prepend">
                      <span className="text-medium-emphasis small">Wednesday</span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress thin color="info" value={12} />
                      <CProgress thin color="danger" value={67} />
                    </div>
                  </div>
                  <div className="progress-group mb-4">
                    <div className="progress-group-prepend">
                      <span className="text-medium-emphasis small">Thursday</span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress thin color="info" value={43} />
                      <CProgress thin color="danger" value={91} />
                    </div>
                  </div>
                  <div className="progress-group mb-4">
                    <div className="progress-group-prepend">
                      <span className="text-medium-emphasis small">Friday</span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress thin color="info" value={22} />
                      <CProgress thin color="danger" value={73} />
                    </div>
                  </div>
                  <div className="progress-group mb-4">
                    <div className="progress-group-prepend">
                      <span className="text-medium-emphasis small">Saturday</span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress thin color="info" value={53} />
                      <CProgress thin color="danger" value={82} />
                    </div>
                  </div>
                  <div className="progress-group mb-4">
                    <div className="progress-group-prepend">
                      <span className="text-medium-emphasis small">Sunday</span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress thin color="info" value={9} />
                      <CProgress thin color="danger" value={69} />
                    </div>
                  </div>
                </CCol>

                <CCol xs={12} md={6} xl={6}>
                  <CRow>
                    <CCol sm={6}>
                      <div className="border-start border-start-4 border-start-warning py-1 px-3 mb-3">
                        <div className="text-medium-emphasis small">Pageviews</div>
                        <div className="fs-5 fw-semibold">78,623</div>
                      </div>
                    </CCol>
                    <CCol sm={6}>
                      <div className="border-start border-start-4 border-start-success py-1 px-3 mb-3">
                        <div className="text-medium-emphasis small">Organic</div>
                        <div className="fs-5 fw-semibold">49,123</div>
                      </div>
                    </CCol>
                  </CRow>

                  <hr className="mt-0" />

                  <div className="progress-group mb-4">
                    <div className="progress-group-header">
                      <CIcon className="icon icon-lg me-2" icon={cilUser} />
                      <span>Male</span>
                      <span className="ms-auto font-semibold">43%</span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress thin color="warning" value={43} />
                    </div>
                  </div>
                  <div className="progress-group mb-5">
                    <div className="progress-group-header">
                      <CIcon className="icon icon-lg me-2" icon={cilUserFemale} />
                      <span>Female</span>
                      <span className="ms-auto font-semibold">37%</span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress thin color="warning" value={37} />
                    </div>
                  </div>

                  <div className="progress-group">
                    <div className="progress-group-header">
                      <CIcon className="icon icon-lg me-2" icon={cibGoogle} />
                      <span>Organic Search</span>
                      <span className="ms-auto font-semibold">
                        191,235 <span className="text-medium-emphasis small">(56%)</span>
                      </span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress thin color="success" value={56} />
                    </div>
                  </div>
                  <div className="progress-group">
                    <div className="progress-group-header">
                      <CIcon className="icon icon-lg me-2" icon={cibFacebook} />
                      <span>Facebook</span>
                      <span className="ms-auto font-semibold">
                        51,223 <span className="text-medium-emphasis small">(15%)</span>
                      </span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress thin color="success" value={15} />
                    </div>
                  </div>
                  <div className="progress-group">
                    <div className="progress-group-header">
                      <CIcon className="icon icon-lg me-2" icon={cibTwitter} />
                      <span>Twitter</span>
                      <span className="ms-auto font-semibold">
                        37,564 <span className="text-medium-emphasis small">(11%)</span>
                      </span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress thin color="success" value={11} />
                    </div>
                  </div>
                  <div className="progress-group">
                    <div className="progress-group-header">
                      <CIcon className="icon icon-lg me-2" icon={cibLinkedin} />
                      <span>LinkedIn</span>
                      <span className="ms-auto font-semibold">
                        27,319 <span className="text-medium-emphasis small">(8%)</span>
                      </span>
                    </div>
                    <div className="progress-group-bars">
                      <CProgress thin color="success" value={8} />
                    </div>
                  </div>
                </CCol>
              </CRow>

              <br />

              <CTable hover responsive align="middle" className="mb-0 border">
                <CTableHead color="light">
                  <CTableRow>
                    <CTableHeaderCell className="text-center">
                      <CIcon icon={cilPeople} />
                    </CTableHeaderCell>
                    <CTableHeaderCell>User</CTableHeaderCell>
                    <CTableHeaderCell className="text-center">Country</CTableHeaderCell>
                    <CTableHeaderCell>Usage</CTableHeaderCell>
                    <CTableHeaderCell className="text-center">Payment Method</CTableHeaderCell>
                    <CTableHeaderCell>Activity</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  <CTableRow>
                    <CTableDataCell className="text-center">
                      <CAvatar size="md" src="/avatars/1.jpg" status="success" />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div>Yiorgos Avraamu</div>
                      <div className="small text-medium-emphasis">
                        <span>New</span> | Registered: Jan 1, 2015
                      </div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CIcon size="xl" icon={cifUs} title="us" id="us" />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div className="clearfix">
                        <div className="float-start">
                          <strong>50%</strong>
                        </div>
                        <div className="float-end">
                          <small className="text-medium-emphasis">
                            Jun 11, 2015 - Jul 10, 2015
                          </small>
                        </div>
                      </div>
                      <CProgress thin color="success" value={50} />
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CIcon size="xl" icon={cibCcMastercard} />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div className="small text-medium-emphasis">Last login</div>
                      <strong>10 sec ago</strong>
                    </CTableDataCell>
                  </CTableRow>
                  <CTableRow>
                    <CTableDataCell className="text-center">
                      <CAvatar size="md" src="/avatars/2.jpg" status="danger" />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div>Avram Tarasios</div>
                      <div className="small text-medium-emphasis">
                        <span>Recurring</span> | Registered: Jan 1, 2015
                      </div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CIcon size="xl" icon={cifBr} title="br" id="br" />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div className="clearfix">
                        <div className="float-start">
                          <strong>10%</strong>
                        </div>
                        <div className="float-end">
                          <small className="text-medium-emphasis">
                            Jun 11, 2015 - Jul 10, 2015
                          </small>
                        </div>
                      </div>
                      <CProgress thin color="info" value={10} />
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CIcon size="xl" icon={cibCcVisa} />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div className="small text-medium-emphasis">Last login</div>
                      <strong>5 minutes ago</strong>
                    </CTableDataCell>
                  </CTableRow>
                  <CTableRow>
                    <CTableDataCell className="text-center">
                      <CAvatar size="md" src="/avatars/3.jpg" status="warning" />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div>Quintin Ed</div>
                      <div className="small text-medium-emphasis">
                        <span>New</span> | Registered: Jan 1, 2015
                      </div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CIcon size="xl" icon={cifIn} title="in" id="in" />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div className="clearfix">
                        <div className="float-start">
                          <strong>74%</strong>
                        </div>
                        <div className="float-end">
                          <small className="text-medium-emphasis">
                            Jun 11, 2015 - Jul 10, 2015
                          </small>
                        </div>
                      </div>
                      <CProgress thin color="warning" value={74} />
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CIcon size="xl" icon={cibCcStripe} />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div className="small text-medium-emphasis">Last login</div>
                      <strong>1 hour ago</strong>
                    </CTableDataCell>
                  </CTableRow>
                  <CTableRow>
                    <CTableDataCell className="text-center">
                      <CAvatar size="md" src="/avatars/4.jpg" status="secondary" />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div>Enéas Kwadwo</div>
                      <div className="small text-medium-emphasis">
                        <span>New</span> | Registered: Jan 1, 2015
                      </div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CIcon size="xl" icon={cifFr} title="fr" id="fr" />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div className="clearfix">
                        <div className="float-start">
                          <strong>98%</strong>
                        </div>
                        <div className="float-end">
                          <small className="text-medium-emphasis">
                            Jun 11, 2015 - Jul 10, 2015
                          </small>
                        </div>
                      </div>
                      <CProgress thin color="danger" value={98} />
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CIcon size="xl" icon={cibCcPaypal} />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div className="small text-medium-emphasis">Last login</div>
                      <strong>Last month</strong>
                    </CTableDataCell>
                  </CTableRow>
                  <CTableRow>
                    <CTableDataCell className="text-center">
                      <CAvatar size="md" src="/avatars/5.jpg" status="success" />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div>Agapetus Tadeáš</div>
                      <div className="small text-medium-emphasis">
                        <span>New</span> | Registered: Jan 1, 2015
                      </div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CIcon size="xl" icon={cifEs} title="es" id="es" />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div className="clearfix">
                        <div className="float-start">
                          <strong>22%</strong>
                        </div>
                        <div className="float-end">
                          <small className="text-medium-emphasis">
                            Jun 11, 2015 - Jul 10, 2015
                          </small>
                        </div>
                      </div>
                      <CProgress thin color="info" value={22} />
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CIcon size="xl" icon={cibCcApplePay} />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div className="small text-medium-emphasis">Last login</div>
                      <strong>Last week</strong>
                    </CTableDataCell>
                  </CTableRow>
                  <CTableRow>
                    <CTableDataCell className="text-center">
                      <CAvatar size="md" src="/avatars/6.jpg" status="danger" />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div>Friderik Dávid</div>
                      <div className="small text-medium-emphasis">
                        <span>New</span> | Registered: Jan 1, 2015
                      </div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CIcon size="xl" icon={cifPl} title="pl" id="pl" />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div className="clearfix">
                        <div className="float-start">
                          <strong>43%</strong>
                        </div>
                        <div className="float-end">
                          <small className="text-medium-emphasis">
                            Jun 11, 2015 - Jul 10, 2015
                          </small>
                        </div>
                      </div>
                      <CProgress thin color="success" value={43} />
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CIcon size="xl" icon={cibCcAmex} />
                    </CTableDataCell>
                    <CTableDataCell>
                      <div className="small text-medium-emphasis">Last login</div>
                      <strong>Yesterday</strong>
                    </CTableDataCell>
                  </CTableRow>
                </CTableBody>
              </CTable>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow> */}
    </>
  )
}

export default Dashboard
